/**
 * Lives in `electron/shared` because both the renderer and main send TZ
 * headers. Not re-exported from the barrel on purpose.
 */

const RECHECK_MS = 60_000;
let cached: { timeZone: string; offset: number; checkedAt: number } | null =
  null;

export function getDeviceTimeZone(): string {
  const now = Date.now();
  const offset = new Date(now).getTimezoneOffset();
  const age = cached ? now - cached.checkedAt : -1;
  if (cached && cached.offset === offset && age >= 0 && age < RECHECK_MS) {
    return cached.timeZone;
  }
  const resolved = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const timeZone = !resolved || resolved === 'undefined' ? 'UTC' : resolved;
  cached = { timeZone, offset, checkedAt: now };
  return timeZone;
}
